document.addEventListener('DOMContentLoaded', function() {
    // Seleziona il div che vuoi distruggere
    var div = document.querySelector('#AnchorLogo--sections--21992725905754__section_anchor_logo_arc8aM');

    // Controlla se l'elemento esiste
    if (div) {
        // Imposta un timeout di 2 secondi (2000 millisecondi)
        setTimeout(function() {
            div.parentNode.removeChild(div); // Rimuove il div dal DOM
        }, 2000);
    } else {
        console.log('Elemento non trovato');
    }
});


/*******************************cambio dimensione immagine swatch in pagina dettaglio prodotto************************************/
// Funzione per aggiornare gli URL delle immagini
function updateImageUrls() {
    var swatchElements = document.querySelectorAll('.swatchProductColor div');

    swatchElements.forEach(function(element) {
        var backgroundImage = element.style.backgroundImage;
        
        if (backgroundImage && backgroundImage.includes('_small')) {
            var newBackgroundImage = backgroundImage.replace('_small', '');
            element.style.backgroundImage = newBackgroundImage;
            console.log('Updated:', newBackgroundImage);
        }
    });
}

// Crea un MutationObserver per osservare cambiamenti nel DOM
var observer = new MutationObserver(function(mutationsList, observer) {
    for (var mutation of mutationsList) {
        if (mutation.type === 'childList') {
            updateImageUrls();
        }
    }
});

// Avvia l'osservazione del corpo del documento per eventuali aggiunte di nodi
observer.observe(document.body, { childList: true, subtree: true });

// Inizialmente chiama la funzione per aggiornare gli URL se gli elementi sono già presenti
updateImageUrls();